import React from "react";

const ApprovedDetails = ({ distribution, application }) => {
  if (!distribution) {
    return (
      <div className="bg-[#131313] rounded-lg p-4 mb-4 text-center">
        <p className="text-gray-400">No approved details available.</p>
      </div>
    );
  }

  const formatCurrency = (amount) => {
    if (typeof amount === "number") {
      return `₹${new Intl.NumberFormat("en-IN").format(amount)}`;
    }
    return "-";
  };

  const partnerDetails = distribution.bankingPartner || {};
  const loanDetails = distribution.loan || {}; // Original loan request details, if needed for fallbacks

  const processingType =
    partnerDetails.bankName === "Lono Micro Finance Bank"
      ? "Internal (Self Bank)"
      : "External (Banking Partner)";

  return (
    <div className="bg-[#131313] rounded-lg p-4 mb-4">
      <div className="flex items-center mb-4">
        <span className="text-white text-lg mr-2">✓</span>
        <h3 className="text-white text-lg">Approved Details</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-gray-400 text-sm">Approved Amount</p>
          <p className="text-[#FFCA20] text-xl font-bold">
            {formatCurrency(distribution.approveAmount || application.approvedAmount || application.principle)}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-sm">Monthly EMI</p>
          <p className="text-white text-xl font-bold">
            {formatCurrency(distribution.emi || application.emi || application.monthlyEmi)}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <p className="text-gray-400 text-sm">Loan Type</p>
          <p className="text-white">{application.loanType || "N/A"}</p>
        </div>
        <div>
          <p className="text-gray-400 text-sm">Tenure</p>
          <p className="text-white">
            {distribution.tenureMonths
              ? `${distribution.tenureMonths} months`
              : application.monthsToRepay
              ? `${application.monthsToRepay} months`
              : "N/A"}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-sm">Interest Rate</p>
          <p className="text-white">
            {distribution.interestRateForCustomer + "% p.a"}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-gray-400 text-sm">Processing Fee</p>
          <p className="text-white">
            {formatCurrency(application.processingFee || '-')}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-sm">Insurance Fees</p>
          <p className="text-white">{formatCurrency(application.insuranceFee || '-')}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-gray-400 text-sm">Applied Insurance</p>
          
          <p className="text-white">{formatCurrency(application.insuranceFee || '-')}</p>
        </div>
        <div>
          <p className="text-gray-400 text-sm">Platform Fees</p>
          <p className="text-white">{formatCurrency(application.platformFee || '-')}</p>
        </div>
      </div>

      {partnerDetails.bankName && (
        <div className="border-t border-[#333333] pt-4 mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <p className="text-gray-400 text-sm">Processing Type</p>
              <p className="text-white">{processingType}</p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p className="text-gray-400 text-sm">Bank Type</p>
              <p className="text-white">{partnerDetails.bankCategory || "N/A"}</p>
            </div>
            <div>
              <p className="text-gray-400 text-sm">Bank Name</p>
              <p className="text-white">{partnerDetails.bankName || "N/A"}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApprovedDetails;
